import styles from "@css/modules/Resort.module.scss"
import Image from "next/image"
import { SlideAppear } from "../../Animation/SlideAppear"

export function FeatureActivities({ title, background, background_desc, background_title, feature_image, feature_desc, feature_title }) {
    return (
        <SlideAppear className={styles.activitiesRoot}>
            <div className={styles.title}>{title}</div>
            <div className={styles.bg} style={{ background: `url(${background?.url})` }}>
                <div className={styles.bgTitle}>{background_title}</div>
                <div className={styles.text}>{background_desc}</div>
            </div>
            <div className={styles.bottomPart}>
                {feature_image && (
                    <Image
                        loading="lazy"
                        className={styles.img}
                        src={feature_image.url}
                        alt={feature_image.alternativeText || "feature preview"}
                        width={feature_image.width}
                        height={feature_image.height}
                    />
                )}
                <div>
                    <div className={styles.previewTitle}>{feature_title}</div>
                    <div className={styles.previewDesc}>{feature_desc}</div>
                </div>
            </div>
        </SlideAppear>
    )
}
